import type { ThemeColors } from '../../../tokens/colors/types';
import cobaltDeprecated from '../../cobalt/colors/deprecated';

export default (baseColors: ThemeColors, brandSecondary?: string) => {
  const deprecated = cobaltDeprecated(baseColors, brandSecondary);
  return {
    ...deprecated,
    positive: {
      ...(deprecated.positive as Record<string, string>),
      default: baseColors.green['70'],
    },
    informative: {
      ...(deprecated.informative as Record<string, string>),
      default: baseColors.blue['70'],
    },
    warning: {
      ...(deprecated.warning as Record<string, string>),
      default: baseColors.orange['70'],
    },
    negative: {
      ...(deprecated.negative as Record<string, string>),
      default: baseColors.red['70'],
    },
    critical: {
      ...(deprecated.critical as Record<string, string>),
      default: baseColors.red['70'],
    },
  };
};
